package one.healthium.update_food_preferences.data.mapper

import one.healthium.update_food_preferences.data.dto.FoodPreferenceOptionDto
import one.healthium.update_food_preferences.data.dto.FoodPreferencesCategoryOptionsDto
import one.healthium.update_food_preferences.data.dto.FoodPreferencesDto
import one.healthium.update_food_preferences.domain.models.FoodPreferenceCategoryOptions
import one.healthium.update_food_preferences.domain.models.FoodPreferenceItemModel
import one.healthium.update_food_preferences.domain.models.FoodPreferenceStatus
import one.healthium.update_food_preferences.domain.models.FoodPreferencesCategoryModel

internal class FoodPreferencesMapper {
    fun dtoToModel(dto: FoodPreferencesDto): List<FoodPreferencesCategoryModel> {
        return dto.preferences.map {
            FoodPreferencesCategoryModel(
                id = it.id,
                description = it.description,
                availableStatuses = it.availableStatuses.map { status -> status.toFoodPreferenceStatus() },
                options = it.answers.map { answerDto ->
                    FoodPreferenceItemModel(
                        id = answerDto.id,
                        text = answerDto.text,
                        status = answerDto.status.toFoodPreferenceStatus()
                    )
                }
            )
        }
    }

    fun optionToDto(options: List<FoodPreferenceCategoryOptions>): List<FoodPreferencesCategoryOptionsDto> {
        return options.map { categoryOptions ->
            FoodPreferencesCategoryOptionsDto(
                id = categoryOptions.id,
                options = categoryOptions.options.map {
                    FoodPreferenceOptionDto(
                        id = it.id,
                        status = it.status.toDto()
                    )
                },
            )
        }
    }

    private fun String.toFoodPreferenceStatus(): FoodPreferenceStatus = when (this) {
        "included" -> FoodPreferenceStatus.Included
        "excluded" -> FoodPreferenceStatus.Excluded
        "neutral" -> FoodPreferenceStatus.Neutral
        else -> FoodPreferenceStatus.Neutral
    }

    private fun FoodPreferenceStatus.toDto() = when (this) {
        FoodPreferenceStatus.Included -> "included"
        FoodPreferenceStatus.Excluded -> "excluded"
        FoodPreferenceStatus.Neutral -> "neutral"
    }
}